import {
    FaUserCircle,
} from "react-icons/fa";

import styles from "./WelcomeHero.module.css";

const WelcomeHero = ({

    user,

}) => {

    return (

        <section className={styles.card}>

            <div className={styles.avatar}>

                {

                    user?.imageUrl

                        ?

                        <img

                            src={user.imageUrl}

                            alt={user.fullName}

                        />

                        :

                        <FaUserCircle />

                }

            </div>

            <div className={styles.content}>

                <span className={styles.hello}>

                    👋 سلام

                </span>

                <h2>

                    {

                        user?.fullName ||

                        "کاربر گرامی"

                    }

                </h2>

                <p>

                    به

                    <strong>

                        {" "}اتویاد{" "}

                    </strong>

                    خوش آمدید.

                </p>

                <small>
                    همه چیز برای مدیریت خودروهایتان آماده است.
                </small>

            </div>

        </section>

    );

};

export default WelcomeHero;